/**
 * standPlanService.js — where a stand is DRAWN on the fdsVector hall plans (backlog #209).
 *
 * Reads FDS-Backend's shape-to-stand link table (backlog #167, filled by fdsVector on every save, #168):
 *   GET /api/v2/vector/stands/{standId}/shapes   staff only; [] = the stand is not drawn in any plan
 * It lives OUTSIDE /api/v1 (FdsVectorController, "/api/v2/vector"), so the origin is JAVA_BACKEND_ORIGIN.
 *
 * Never throws: the page shows the plan section either way. `ok:false` means "could not ask" (403 for a
 * non-staff login, network, an older backend without the endpoint), which is NOT the same as "not drawn" -
 * the caller then falls back on what the embedded plan itself reports (the isolate result event).
 */
import axios from 'axios';
import { JAVA_BACKEND_ORIGIN, getAuthHeader } from '../Components/Contexts/BackendConstants';

const VECTOR = `${JAVA_BACKEND_ORIGIN}/api/v2/vector`;

/**
 * @returns {Promise<{ok: boolean, shapes: Array<{standId:number, fuarId:number, salonId:number, documentId:string, shapeId:string}>, message?: string}>}
 */
export async function getStandShapes(standId) {
  if (standId == null || !/^\d+$/.test(String(standId))) return { ok: false, shapes: [], message: 'no numeric standId' };
  try {
    const res = await axios.get(`${VECTOR}/stands/${standId}/shapes`, { headers: getAuthHeader() });
    return { ok: true, shapes: Array.isArray(res.data) ? res.data : [] };
  } catch (e) {
    return { ok: false, shapes: [], message: e?.response?.status ? `HTTP ${e.response.status}` : String(e?.message || e) };
  }
}

/**
 * Is the stand drawn in the given hall? `shapes` are the rows of getStandShapes. A row without a salonId counts
 * for any hall (an old link written before the hall was recorded); otherwise the hall has to be the stand's own.
 */
export function standDrawnInHall(shapes, salonId) {
  return (shapes || []).some((sh) => sh.salonId == null || salonId == null || String(sh.salonId) === String(salonId));
}
